import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import ModalVerifyArtist from "@components/ModalVerifyArtist";
import Table from "@components/Table";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import { ActionButtonType } from "@enums/actionButtonType";
import { ArtistVerified } from "@enums/artistVerified";
import { downloadCSV } from "@helpers/csv.helper";
import useListArtist from "@hooks/Artist/useListArtist";
import useListColumns from "@hooks/Artist/useListColumns";
import useListItems from "@hooks/Shared/useListItems";
import listMapper from "@mappers/Modules/artist/ListArtist.mapper";
import getArtists from "@services/Artist/getArtists";
import BanIcon from "mdi-react/AccountCancelOutlineIcon";
import { ReactElement } from "react";
import { Container } from "reactstrap";
import styles from "./ListArtist.module.scss";

const ListItems = (): ReactElement => {
  const COLUMNS = useListColumns();
  const { isLoading, basicData, tableItems, getItems } = useListItems(
    getArtists,
    listMapper
  );

  const {
    isBanOrFeatureModalOpen,
    isVerifyModalOpen,
    handleBan,
    handleVerify,
    handleFeature,
    handleIsBanOrFeatureModalOpen,
    handleIsVerifyModalOpen,
    actionButtonType,
  } = useListArtist(basicData, getItems);

  if (isLoading) {
    return <Loader />;
  }

  const isBan = actionButtonType === ActionButtonType.Ban;
  const banConfirmText = basicData?.banned ? "unban" : "ban";
  const featureConfirmText = basicData?.featured ? "unfeature" : "feature";

  return (
    <Container className={styles.listArtist}>
      <ModalConfirmation
        icon={BanIcon}
        title={`Artists | ${isBan ? "Ban" : "Feature"} confirmation`}
        body={`Do you confirm to ${
          isBan ? banConfirmText : featureConfirmText
        } the artist:  "${basicData?.description}" ?`}
        handleConfirm={isBan ? handleBan : handleFeature}
        handleModalStatus={handleIsBanOrFeatureModalOpen}
        modalStatus={isBanOrFeatureModalOpen}
        modalType={EUiStates.DANGER}
      />

      <ModalVerifyArtist
        artistWalletAddress={basicData?.description!}
        artistVerified={basicData?.verified as ArtistVerified}
        handleConfirm={handleVerify}
        handleModalStatus={handleIsVerifyModalOpen}
        modalStatus={isVerifyModalOpen}
        modalType={EUiStates.DANGER}
      />

      <div className={styles.header}>
        <Title />
        <button
          className="btn-sm btn-danger btn btn-secondary"
          onClick={() =>
            downloadCSV(tableItems, "users.csv", [
              "uuid",
              "artistName",
              "description",
              "createdAt",
              "banned",
              "walletAddress",
            ])
          }
        >
          Download
        </button>
      </div>
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
